export default {
    nav: 'Feedback',
    dialog: {
        titleList: 'My Feedback',
        titleNew: 'New Feedback',
        titleDetail: 'Feedback Detail',
    },
    list: {
        new: 'New Feedback',
        loading: 'Loading...',
        empty: 'No feedback yet — your thoughts help us build a better product',
        delete: 'Delete',
    },
    status: {
        pending: 'Pending',
        processing: 'Processing',
        resolved: 'Resolved',
        closed: 'Closed',
    },
    category: {
        bug: 'Bug',
        suggestion: 'Suggestion',
        feature_request: 'Feature Request',
        other: 'Other',
    },
    form: {
        intro: 'Your feedback matters — every submission is read by our team',
        titleLabel: 'Title',
        titlePlaceholder: 'Briefly describe the issue or suggestion',
        categoryLabel: 'Category',
        contentLabel: 'Description',
        contentPlaceholder: 'Please describe in detail — the more context, the better...',
        cancel: 'Cancel',
        submit: 'Submit Feedback',
        submitting: 'Submitting...',
        bold: 'Bold',
        italic: 'Italic',
        strikethrough: 'Strikethrough',
        bulletList: 'Bullet List',
        orderedList: 'Ordered List',
        blockquote: 'Blockquote',
    },
    success: {
        title: 'Thank you for your feedback!',
        message: 'We\'ve received your submission and our team will review it carefully. Every piece of feedback helps us improve.',
        viewList: 'View my feedback',
    },
    detail: {
        back: 'Back to list',
        replyPlaceholder: 'Add a reply...',
        send: 'Send',
        sending: 'Sending',
        uploadImage: 'Upload image',
    },
};
